import React from 'react';
import styled from 'styled-components';
import { Activity } from 'react-feather';
import useTranslation from 'next-translate/useTranslation';
import { style } from '../../../../api';
import Button from '../../../../VuexyDesign/atoms/Button';

export default styled(({ className }: { className?: string }) => {
  const { t } = useTranslation('profile');
  return (
    <Button color="success" className={className}>
      <>
        <Activity size={14} color={style.white} className="mr-50" />
        {t('profile:viewStats')}
      </>
    </Button>
  );
})``;
